import { gql } from "graphql-request"

export const createVesselMutation = gql`
mutation CreateVessel($input: createVessel!) {
	createVessel(input: $input) {
    	id
	}
}
`
